export const animationTiming = {
  glideTime: 1500,
  fadeTime: 1250,
};

export const animationTimingFast = {
  glideTime: 250,
  fadeTime: 250,
};

export const AUD = 'AUD';

export const DEFAULT_CAROUSEL_NUM_ITEMS = 8;
